export enum Language {
  DUTCH = 'nl',
  ENGLISH = 'en'
}

export enum Platform {
  PRODUCTION = 'production',
  ACCEPTANCE = 'acceptance',
  TEST = 'test',
  DEVELOPMENT = 'development',
  UNIT_TEST = 'unit_test'
}

export enum PlatformUrl {
  PRODUCTION = 'www.ns.nl',
  ACCEPTANCE = 'acc.ns.nl',
  TEST = 'test.ns.nl',
  DEVELOPMENT = 'localhost'
}

export enum AccountType {
  CARD_HOLDER = 'kaarthouder',
  CONTACT_PERSON = 'contactpersoon'
}

export enum MessageType {
  RESET_ACCOUNT_SUCCESS = 'RESET_ACCOUNT_SUCCESS',
  ACTIVATE_SUCCESS = 'ACTIVATE_SUCCESS'
}

export enum ResponseErrorLevel {
  ERROR = 'ERROR',
  INFO = 'INFO'
}

export enum Relay42Category {
  BUTTON_CLICK = 'userinteractie/clicks/button/'
}

export enum SupportRole {
  CIC_GEBRUIKER = 'CIC',
  SALES_GEBRUIKER = 'SAL'
}
